//JS Imports
import { windowIsSmallerThan, toggleDarkMode } from './helpers'
import Lenis from 'lenis'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

//Lenis
const lenis = new Lenis({
    duration: 1.3,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t))
})

function raf(time) {
  lenis.raf(time)
  requestAnimationFrame(raf)
}

//Start raf loop    
requestAnimationFrame(raf)

jQuery(document).ready(function ($) { 

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      lenis.scrollTo(this.getAttribute('href'))
    });
  })
  
  // Add Lenis Prevent to Mobile Menu
  $(document).on('click', '#mobile-menu-control-wrapper .menu-toggle', function() {
    if ( $('.mobile-menu-open').length > 0 ) {
      lenis.stop();
      $('#site-navigation').attr("data-lenis-prevent", "true");
            $('header.site-header').addClass("is-fixed");

    } else {
      lenis.start();
      $('#site-navigation').removeAttr("data-lenis-prevent");
            $('header.site-header').removeClass("is-fixed");
    }
  });

  // Animate elements with the [animate-in] attribute
  gsap.utils.toArray('[animate-in]').forEach(ele => {
    // console.log(ele);
    const animation = ele.getAttribute('animate-in');
    const animatedSpeed = parseFloat(ele.getAttribute('animate-speed')) || 1;
    const animateDelay = parseFloat(ele.getAttribute('animate-delay')) || 0;

    const animations = {
      animate__flip: () => {
        gsap.set(ele, { y: 100, rotation: 0 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          y: 0,
          rotation: 360,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeIn: () => {
        // gsap.set(ele, { opacity: 0 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeInUp: () => {
        gsap.set(ele, { y: 100 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          y: 0,
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeInDown: () => {
        gsap.set(ele, { y: -100 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          y: 0,
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeInLeft: () => {
        gsap.set(ele, { x: -100 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          x: 0,
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      },
      animate__fadeInRight: () => {
        gsap.set(ele, { x: 100 });
        gsap.to(ele, {
          scrollTrigger: {
            trigger: ele,
            start: "top 85%"
          },
          x: 0,
          opacity: 1,
          duration: animatedSpeed,
          delay: animateDelay
        });
      }
    };

    if (animations[animation]) animations[animation]();
  });


  if($(".single-post-share").length > 0){
    // ScrollTrigger.create({
    //   trigger: "body",
    //   pin: ".single-post-share",
    //   start: "top top-=1",
    //   endTrigger: "body",
    //   end: "bottom bottom",
    //   pinSpacing: false
    // });

    // if this reaches the top make it fixed to the bottom 80px 
    ScrollTrigger.create({
      trigger: ".single-post-share",
      start: "top top+=80",
      endTrigger: "body",
      end: "bottom bottom",
      toggleClass: {targets: ".single-post-share", className: "is-fixed"}
    });
  }
 
  
})